//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TeamMembers from './TeamMembers.vue';
import OrganizationResources from './OrganizationResources.vue';
import TimelineChart from './TimelineChart.vue';
import OrganizationIndicators from './OrganizationIndicators.vue';
import LookerDashboardComponent from '@/components/LookerDashboardComponent.vue';
export default {
  name: 'ViewDashboard',
  components: {
    TeamMembers: TeamMembers,
    OrganizationResources: OrganizationResources,
    TimelineChart: TimelineChart,
    OrganizationIndicators: OrganizationIndicators,
    LookerDashboardComponent: LookerDashboardComponent
  },
  data: function data() {
    return {
      rowClass: {
        'pl-0 pt-2': this.$vuetify.breakpoint.mdAndUp,
        'pl-0 pt-4': this.$vuetify.breakpoint.smAndDown
      },
      url: process.env.VUE_APP_CHATBOT_DASHBOARD
    };
  },
  computed: {
    getClassMembers: function getClassMembers() {
      return 'col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12';
    },
    getClassResources: function getClassResources() {
      return 'col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12';
    },
    getClassConversations: function getClassConversations() {
      return 'col-md-12 col-sm-12';
    },
    getClassMetrics: function getClassMetrics() {
      return 'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12';
    }
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    }
  }
};